/**
 * Action Types
 */
export var USER_DETAILS = 'USER/DETAILS';
export var USER_ACCOUNTS = 'USER/ACCOUNTS';
export var USER_USERS = 'USER/USERS';
export var SET_FEATURE_FLAGS = 'USER/SET_FEATURE_FLAGS';
export var FEATURE_FLAG_NAMES = ['profitability', 'signal-dashboard'];